(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["custom-byb"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__bybBundleInit) {
      window.__bybBundleRefresh && window.__bybBundleRefresh(document);
      return;
    }

    window.__bybBundleInit = true;

    function getProductForm(section) {
      var selector = section.dataset.formSelector || 'form[action*="/cart/add"]';
      return document.querySelector(selector) || document.querySelector('form[action*="/cart/add"]');
    }

    function showError(section, message) {
      var errorEl = section.querySelector('[data-byb-error]');
      if (!errorEl) return;
      errorEl.textContent = message;
      errorEl.hidden = false;
    }

    function clearError(section) {
      var errorEl = section.querySelector('[data-byb-error]');
      if (!errorEl) return;
      errorEl.textContent = '';
      errorEl.hidden = true;
    }

    function getCheckedBundleItems(section) {
      var bundleProperties = {};

      if (section.dataset.addBundleProperties === 'true') {
        if (section.dataset.bundleParent) {
          bundleProperties._bundle_parent = section.dataset.bundleParent;
        }

        if (section.dataset.bundleParentId) {
          bundleProperties._bundle_parent_id = section.dataset.bundleParentId;
        }
      }

      return Array.prototype.slice.call(section.querySelectorAll('[data-byb-item]'))
        .filter(function (item) {
          var checkbox = item.querySelector('[data-byb-checkbox]');
          return checkbox && checkbox.checked;
        })
        .map(function (item) {
          var variantInput = item.querySelector('[data-byb-variant-select]');
          var cartItem = {
            id: Number(variantInput && variantInput.value),
            quantity: 1
          };

          if (Object.keys(bundleProperties).length > 0) {
            cartItem.properties = Object.assign({}, bundleProperties);
          }

          return cartItem;
        })
        .filter(function (item) {
          return Number.isFinite(item.id) && item.id > 0;
        });
    }

    function getMainCartItem(form) {
      var formData = new FormData(form);
      var id = Number(formData.get('id'));
      var quantity = Number(formData.get('quantity') || 1);

      if (!Number.isFinite(id) || id <= 0) return null;

      var item = {
        id: id,
        quantity: Number.isFinite(quantity) && quantity > 0 ? quantity : 1
      };
      var sellingPlan = formData.get('selling_plan');
      var properties = {};

      if (sellingPlan) item.selling_plan = Number(sellingPlan);

      formData.forEach(function (value, key) {
        var match = key.match(/^properties\[(.+)\]$/);
        if (match && value !== '') properties[match[1]] = value;
      });

      if (Object.keys(properties).length > 0) item.properties = properties;

      return item;
    }

    function setFormLoading(form, isLoading) {
      var controls = form.querySelectorAll('button[type="submit"], input[type="submit"]');
      controls.forEach(function (control) {
        if (isLoading) {
          control.dataset.bybWasDisabled = control.disabled ? 'true' : 'false';
          control.disabled = true;
          control.setAttribute('aria-busy', 'true');
        } else if (control.dataset.bybWasDisabled !== 'true') {
          control.disabled = false;
          control.removeAttribute('aria-busy');
        }
      });
    }

    function refreshCartUi() {
      var detail = { data: {} };

      document.dispatchEvent(new CustomEvent('cart:updated', { detail: detail }));
      document.dispatchEvent(new CustomEvent('cart:update', { detail: detail }));
      document.dispatchEvent(new CustomEvent('cart:change', { detail: detail }));
      document.dispatchEvent(new CustomEvent('cart:refresh', { detail: detail }));
      document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: detail }));

      var cartDrawer = document.querySelector('cart-drawer');
      var cartDrawerComponent = document.querySelector('cart-drawer-component');

      if (cartDrawerComponent && typeof cartDrawerComponent.open === 'function') {
        setTimeout(function () {
          cartDrawerComponent.open();
        }, 250);
        return Promise.resolve(true);
      }

      if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
        return fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart.js', {
          headers: { Accept: 'application/json' }
        })
          .then(function (response) { return response.json(); })
          .then(function (cart) {
            cartDrawer.renderContents(cart);
            return true;
          })
          .catch(function () { return false; });
      }

      if (cartDrawer && typeof cartDrawer.open === 'function') {
        cartDrawer.open();
        return Promise.resolve(true);
      }

      var cartNotification = document.querySelector('cart-notification');
      if (cartNotification && typeof cartNotification.open === 'function') {
        cartNotification.open();
        return Promise.resolve(true);
      }

      return Promise.resolve(true);
    }

    function hasCheckedBundleItems(section) {
      return !!section.querySelector('[data-byb-checkbox]:checked');
    }

    function handleAddToCart(event, section, form) {
      var bundleItems = getCheckedBundleItems(section);
      var genericError = section.dataset.genericError || 'Something went wrong while adding your bundle. Please try again.';

      if (bundleItems.length === 0) return;
      if (section.dataset.bybSubmitting === 'true') return;

      event.preventDefault();
      event.stopImmediatePropagation();
      section.dataset.bybSubmitting = 'true';
      clearError(section);

      var mainItem = getMainCartItem(form);
      if (!mainItem) {
        showError(section, genericError);
        section.dataset.bybSubmitting = 'false';
        return;
      }

      var payloadItems = [mainItem].concat(bundleItems);

      if (!payloadItems.length) {
        showError(section, genericError);
        section.dataset.bybSubmitting = 'false';
        return;
      }

      setFormLoading(form, true);

      fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({ items: payloadItems })
      })
        .then(function (response) {
          return response.json().then(function (payload) {
            if (!response.ok) throw new Error(payload && (payload.description || payload.message) || genericError);
            return payload;
          });
        })
        .then(function () { return refreshCartUi(); })
        .catch(function (error) {
          showError(section, error && error.message || genericError);
        })
        .finally(function () {
          section.dataset.bybSubmitting = 'false';
          setFormLoading(form, false);
        });
    }

    function bindVariantSelects(section) {
      var selects = section.querySelectorAll('[data-byb-variant-select]');
      selects.forEach(function (select) {
        if (select.dataset.bybVariantBound === 'true') return;
        select.dataset.bybVariantBound = 'true';
        select.addEventListener('change', function () {
          var selectedOption = select.options && select.options[select.selectedIndex];
          var item = select.closest('[data-byb-item]');
          if (!selectedOption || !item) return;

          var priceEl = item.querySelector('[data-byb-price]');
          var comparePriceEl = item.querySelector('[data-byb-compare-price]');
          var priceWrapper = item.querySelector('.byb-price');
          var checkbox = item.querySelector('[data-byb-checkbox]');

          if (priceEl) priceEl.textContent = selectedOption.dataset.price || '';
          if (checkbox) {
            checkbox.value = selectedOption.value || checkbox.value;
            checkbox.dataset.price = selectedOption.dataset.priceRaw || checkbox.dataset.price || '';
          }
          if (comparePriceEl) {
            comparePriceEl.textContent = selectedOption.dataset.comparePrice || '';
            comparePriceEl.classList.toggle('is-hidden', !selectedOption.dataset.comparePrice);
          }
          if (priceWrapper) {
            priceWrapper.classList.toggle('price--on-sale', !!selectedOption.dataset.comparePrice);
          }
        });
      });
    }

    function syncSelectedRows(section) {
      section.querySelectorAll('[data-byb-item]').forEach(function (item) {
        var checkbox = item.querySelector('[data-byb-checkbox]');
        item.classList.toggle('is-selected', !!(checkbox && checkbox.checked));
      });
      updateSelectedCount(section);
    }

    function updateSelectedCount(section) {
      var countEl = section.querySelector('[data-byb-selected-count]');
      if (!countEl) return;

      var count = section.querySelectorAll('[data-byb-checkbox]:checked').length;
      var label = count === 1
        ? section.dataset.selectedCountSingular || 'selected'
        : section.dataset.selectedCountPlural || 'selected';

      countEl.textContent = count > 0 ? '(' + count + ' ' + label + ')' : '';
      countEl.hidden = count === 0;
    }

    function bindCheckboxes(section) {
      section.querySelectorAll('[data-byb-checkbox]').forEach(function (checkbox) {
        if (checkbox.dataset.bybCheckboxBound === 'true') return;
        checkbox.dataset.bybCheckboxBound = 'true';
        checkbox.addEventListener('change', function () {
          syncSelectedRows(section);
        });
      });
      syncSelectedRows(section);
    }

    function bindRowToggles(section) {
      section.querySelectorAll('[data-byb-item]').forEach(function (item) {
        if (item.dataset.bybRowBound === 'true') return;
        item.dataset.bybRowBound = 'true';

        item.addEventListener('click', function (event) {
          if (event.defaultPrevented) return;
          if (event.target.closest('a, button, input, select, textarea, label')) return;

          var checkbox = item.querySelector('[data-byb-checkbox]');
          if (!checkbox) return;

          checkbox.checked = !checkbox.checked;
          checkbox.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    }

    function sortBundleItems(section) {
      var list = section.querySelector('.byb-list');
      if (!list || list.dataset.bybSorted === 'true') return;

      var items = Array.prototype.slice.call(list.querySelectorAll('[data-byb-item]'));
      if (items.length < 2) return;

      items.sort(function (first, second) {
        var firstSort = Number(first.dataset.sortOrder);
        var secondSort = Number(second.dataset.sortOrder);
        var firstIndex = Number(first.dataset.originalIndex);
        var secondIndex = Number(second.dataset.originalIndex);

        if (!Number.isFinite(firstSort)) firstSort = firstIndex;
        if (!Number.isFinite(secondSort)) secondSort = secondIndex;
        if (firstSort === secondSort) return firstIndex - secondIndex;

        return firstSort - secondSort;
      });

      items.forEach(function (item) {
        list.appendChild(item);
      });

      list.dataset.bybSorted = 'true';
    }

    function bindAccordion(section) {
      var details = section.querySelector('[data-byb-details]');
      if (!details || details.dataset.bybAccordionBound === 'true') return;

      var summary = details.querySelector('summary');
      var panel = details.querySelector('[data-byb-panel]');
      var animation = null;

      if (!summary || !panel) return;

      details.dataset.bybAccordionBound = 'true';

      function clearAnimationState() {
        details.classList.remove('byb-is-opening', 'byb-is-closing');
        panel.style.height = '';
        panel.style.overflow = '';
        animation = null;
      }

      function getPanelHeight() {
        return panel.scrollHeight;
      }

      function openDetails() {
        if (animation) animation.cancel();

        details.open = true;
        details.classList.remove('byb-is-closing');
        details.classList.add('byb-is-opening');
        panel.style.overflow = 'hidden';
        panel.style.height = '0px';

        requestAnimationFrame(function () {
          animation = panel.animate(
            [
              { height: '0px' },
              { height: getPanelHeight() + 'px' }
            ],
            {
              duration: 280,
              easing: 'cubic-bezier(0.22, 1, 0.36, 1)'
            }
          );

          animation.onfinish = clearAnimationState;
          animation.oncancel = clearAnimationState;
        });
      }

      function closeDetails() {
        if (animation) animation.cancel();

        details.classList.remove('byb-is-opening');
        details.classList.add('byb-is-closing');
        panel.style.overflow = 'hidden';
        panel.style.height = getPanelHeight() + 'px';

        requestAnimationFrame(function () {
          animation = panel.animate(
            [
              { height: getPanelHeight() + 'px' },
              { height: '0px' }
            ],
            {
              duration: 240,
              easing: 'cubic-bezier(0.4, 0, 0.2, 1)'
            }
          );

          animation.onfinish = function () {
            details.open = false;
            clearAnimationState();
          };
          animation.oncancel = clearAnimationState;
        });
      }

      summary.addEventListener('click', function (event) {
        if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          return;
        }

        event.preventDefault();

        if (details.open) {
          closeDetails();
        } else {
          openDetails();
        }
      });
    }

    function init(root) {
      var scope = root && root.querySelectorAll ? root : document;
      var sections = scope.matches && scope.matches('[data-byb-section]')
        ? [scope]
        : Array.prototype.slice.call(scope.querySelectorAll('[data-byb-section]'));

      sections.forEach(function (section) {
        sortBundleItems(section);
        bindAccordion(section);
        bindCheckboxes(section);
        bindRowToggles(section);
        bindVariantSelects(section);

        if (section.dataset.bybInitialized === 'true') return;
        section.dataset.bybInitialized = 'true';

        var form = getProductForm(section);
        if (!form) return;

        form.querySelectorAll('button[type="submit"], input[type="submit"], [name="add"]').forEach(function (control) {
          control.addEventListener('click', function (event) {
            if (!hasCheckedBundleItems(section)) return;
            handleAddToCart(event, section, form);
          }, true);
        });

        form.addEventListener('submit', function (event) {
          if (!hasCheckedBundleItems(section)) return;
          handleAddToCart(event, section, form);
        }, true);
      });
    }

    window.__bybBundleRefresh = init;

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { init(document); });
    } else {
      init(document);
    }

    document.addEventListener('shopify:section:load', function (event) { init(event.target); });
    document.addEventListener('shopify:block:select', function (event) { init(event.target); });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["custom-stock-status"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__cylStockInit) {
      window.__cylStockRefresh && window.__cylStockRefresh();
      return;
    }
    window.__cylStockInit = true;

    var cache = new Map();
    var observed = new WeakSet();

    function computeStatus(productData, threshold, onlyIfTracked) {
      var variants = productData.variants || [];
      var trackedCount = 0;
      var trackedQty = 0;
      var anyTracked = false;
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        if (v.inventory_management) {
          anyTracked = true;
          var q = typeof v.inventory_quantity === 'number' ? v.inventory_quantity : 0;
          if (q > 0) {
            trackedCount += 1;
            trackedQty += q;
          }
        }
      }

      if (onlyIfTracked && !anyTracked) return { hide: true };
      if (productData.available === false) return { status: 'out', key: 'out-of-stock' };
      if (trackedCount > 0 && trackedQty <= threshold) return { status: 'low', key: 'low-stock' };
      return { status: 'in', key: 'in-stock' };
    }

    function applyStatus(el, result) {
      if (result.hide) { el.hidden = true; return; }
      el.hidden = false;
      el.classList.remove('cyl-stock--in', 'cyl-stock--low', 'cyl-stock--out');
      el.classList.add('cyl-stock--' + result.status);
      var labelEl = el.querySelector('.cyl-stock__label');
      if (labelEl) {
        var textMap = {
          'in-stock': el.dataset.textInStock,
          'low-stock': el.dataset.textLowStock,
          'out-of-stock': el.dataset.textOutOfStock
        };
        var next = textMap[result.key];
        if (next) labelEl.textContent = next;
      }
    }

    function fetchProduct(handle) {
      if (cache.has(handle)) return cache.get(handle);
      var p = fetch('/products/' + encodeURIComponent(handle) + '.js', {
        headers: { 'Accept': 'application/json' },
        credentials: 'same-origin'
      })
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
      cache.set(handle, p);
      return p;
    }

    function update(el) {
      var handle = el.dataset.handle;
      if (!handle) return;
      var threshold = parseInt(el.dataset.threshold, 10);
      if (isNaN(threshold)) threshold = 5;
      var onlyIfTracked = el.dataset.onlyIfTracked === 'true';
      fetchProduct(handle).then(function (data) {
        if (!data) return;
        applyStatus(el, computeStatus(data, threshold, onlyIfTracked));
      });
    }

    var observer = 'IntersectionObserver' in window
      ? new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) { observer.unobserve(entry.target); update(entry.target); }
          });
        }, { rootMargin: '200px 0px' })
      : null;

    function init(root) {
      var scope = root && root.querySelectorAll ? root : document;
      var nodes = scope.querySelectorAll('[data-cyl-stock]');
      nodes.forEach(function (el) {
        if (observed.has(el)) return;
        observed.add(el);
        if (observer) observer.observe(el); else update(el);
      });
    }

    window.__cylStockRefresh = function () { init(document); };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { init(document); });
    } else {
      init(document);
    }
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
    document.addEventListener('shopify:block:select', function (e) { init(e.target); });
  })();
  } catch(e) { console.error(e); }
})();

})();
